import { render, staticRenderFns } from "./CallcentreDashboard.vue?vue&type=template&id=3dd2e110&"
import script from "./CallcentreDashboard.vue?vue&type=script&lang=js&"
export * from "./CallcentreDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports